'use client'

import { Axios } from '../Axios/Axios'
import { Alert } from "@material-tailwind/react"; // Importing the Alert component
import { XCircleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

export function Notification({ message, type }) {
  return (
    <Alert
      icon={type === 'success' ? <CheckCircleIcon className="h-6 w-6" /> : <XCircleIcon className="h-6 w-6" />}
      className={`fixed bottom-4 left-4 z-50 rounded-lg border-l-4 p-4 max-w-xs w-full shadow-lg transition-all duration-300 ease-in-out transform ${type === 'success' ? 'border-[#2ec946] bg-green-300 text-green-800' : 'border-red-600 bg-red-200 text-red-600'} sm:max-w-md md:max-w-md`}
    >
      {message}
    </Alert>
  );
}
